import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { fallbackCatalog } from '@/data/catalog'
import { api } from '@/services/api'
import type { CatalogResponse, PublicConfigResponse } from '@/types/api'

export const useAppStore = defineStore('app', () => {
  const credits = ref(0)
  const hasActiveSubscription = ref(false)
  const canTopUp = ref(false)
  const subscriptionPaidUntil = ref<string | null>(null)
  const nextCreditGrantAt = ref<string | null>(null)
  const entitlementsKnown = ref(false)
  const entitlementsRefreshing = ref(false)
  const catalog = ref<CatalogResponse>(fallbackCatalog)
  const publicConfig = ref<PublicConfigResponse>({
    payments_enabled: false,
    test_mode: true,
    weekly_intro_offer: false,
    welcome_bonus_enabled: false,
    rewarded_ads_enabled: false,
    hot_content_enabled: true,
  })
  const publicDataLoaded = ref(false)

  const creditLabel = computed(() => credits.value.toLocaleString())

  async function loadPublicData() {
    if (publicDataLoaded.value) return
    const [configResult, catalogResult] = await Promise.allSettled([api.config(), api.catalog()])
    if (configResult.status === 'fulfilled') publicConfig.value = configResult.value
    if (catalogResult.status === 'fulfilled') catalog.value = catalogResult.value
    publicDataLoaded.value = true
  }

  return {
    credits,
    hasActiveSubscription,
    canTopUp,
    subscriptionPaidUntil,
    nextCreditGrantAt,
    entitlementsKnown,
    entitlementsRefreshing,
    catalog,
    publicConfig,
    publicDataLoaded,
    creditLabel,
    loadPublicData,
  }
})
